/** AlpineJS */
import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import persist from '@alpinejs/persist'
import focus from '@alpinejs/focus'

/** jQuery global */
const $ = require('jquery')
window.$ = window.jQuery;

/** Simplebar */
import 'simplebar'

/** DataTables */
// window.DataTable = require('datatables.net');
// require('datatables.net-plugins/pagination/input')

/** JS File Download */
window.fileDownload = require('js-file-download')

/** Axios global */
const Axios = require('axios')
window.Axios = Axios

/** Swiper JS init global */
import Swiper, {Navigation, Lazy} from 'swiper'

Swiper.use([Navigation, Lazy])
window.Swiper = Swiper

/** AlpineJS: init */
window.Alpine = Alpine
Alpine.plugin(collapse)
Alpine.plugin(persist)
Alpine.plugin(focus)

Alpine.store('listsCreate', {
  isOpen: false,
})

Alpine.store('listsProductAdded', {
  isOpen: false,
  listTitle: '',
  listUrl: '',
})

Alpine.store('listsDeleteList', {
  isOpen: false,
  listTitle: '',
  listRef: '',
  listDeleteUrl: '',
})

window.lists_delete_list = function (listTitle, listRef, listDeleteUrl) {
  Alpine.store('listsDeleteList').listTitle = listTitle
  Alpine.store('listsDeleteList').listRef = listRef
  Alpine.store('listsDeleteList').listDeleteUrl = listDeleteUrl

  Alpine.store('listsDeleteList').isOpen = true
}

window.list_export = function (listId) {
  Axios
    .post(window.wp_rest_url + 'genie/v1/lists/export' + '?_wpnonce=' + window.wp_rest_token, {
      listId: listId,
    })
    .catch(function (error) {
      console.log(error)
    })
    .then(function (response) {
      if (response.data.title === undefined || response.data.csv === undefined) {
        return
      }

      window.fileDownload(response.data.csv, response.data.title + '.csv')
    })
}

/** Init Alpine */
Alpine.start()

/** DOM ready */
$(document).ready(() => {
  /** FacetWP loaded event */
  document.addEventListener('facetwp-loaded', function () {
    /** Update category title on category facet change */
    if (window.FWP.facets.category && window.FWP.facets.category.length) {
      let title = $('[data-value=' + window.FWP.facets.category + ']')[0].innerText

      $('#js-category-title').text(title)

    } else {
      let title = $('#js-category-title').attr('data-title')

      $('#js-category-title').text(title)
    }

    /** Update result count */
    let total = window.FWP.settings.pager.total_rows

    $('#js-facet-total').text(total)
  })

  /** WC Wishlists: add product to list */
  $('.js-lists-add-product').click(function (event) {
    Alpine.store('listsProductAdded').listTitle = event.currentTarget.dataset.listTitle
    Alpine.store('listsProductAdded').listUrl = event.currentTarget.dataset.listUrl

    /** Set Wishlist ID hidden input value */
    document.querySelector('input#wlid').value = event.currentTarget.dataset.listId

    let form = document.querySelector('form.cart')
    let formData = new FormData(form)

    /** Hide lists dropdown */
    document.querySelector('#wl-list-pop-wrap').style.display = 'none'
    document.querySelector('.wl-list-pop').style.display = 'none'

    Alpine.store('listsProductAdded').isOpen = true

    Axios
      .post(window.woocommerce_wishlist_add_to_wishlist_url, formData)
      .then(function (response) {
        // console.log(response)
      })
  })
})
